import * as React from 'react';

import { Card } from '@mui/material';
import { CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs/Dialog/Dialog';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { truncateString } from 'utils/truncateString';

type Props = {
  commissionName: string;
} & DialogProps;

export const CommissionsCreateApprovedSuccessDialog: React.FC<Props> = ({
  commissionName,
  ...restProps
}) => {
  return (
    <Dialog {...restProps} fullWidth width="640px">
      <Card>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={restProps.onClose} />]}
          title="Создание и согласование комиссии успешно выполнено"
          titleSize="smallBold"
        />
        <CardContent>
          <Typography>
            Новая комиссия{' '}
            <TypographyBold fontSize={16} text={truncateString(commissionName, 30)} /> успешно
            создана в статусе <TypographyBold fontSize={16} text="“Согласована”" />. Данную комиссию
            нельзя редактировать, но, при необходимости, вы можете её аннулировать.
          </Typography>
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={
            <CancelButton
              key="back-button"
              label="Вернуться в список"
              onClick={restProps.onClose}
              variant="outlined"
            />
          }
        />
      </Card>
    </Dialog>
  );
};
